import angular from 'angular';

export default angular
	.module('ui.cian.scrollWidth', [])
	.factory('cianUiScrollWidth', ['$document', function ($document) {
		let scrollWidth = 0;
		const $body = $document[0].body;

		this.cache = () => {
			if (!scrollWidth) {
				const box = $document[0].createElement('div');
				box.style.position = 'absolute';
				box.style.top = box.style.left = '-9999px';
				box.style.width = box.style.height = '100px';
				box.style.overflow = 'scroll';
				$body.appendChild(box);
				scrollWidth = box.offsetWidth - box.clientWidth;
				angular.element(box).remove();
			}
		};

		/**
		 *
		 * @param selectors Array
		 */
		this.createIndentTo = (selectorsList) => {
			const style = $document[0].createElement('style');
			const selectors = selectorsList.join(', ');
			style.type = 'text/css';
			style.innerHTML = `${selectors} { padding-right: ${scrollWidth}px; }`;
			$document[0].getElementsByTagName('head')[0].appendChild(style);
		};

		this.get = () => {
			return scrollWidth;
		};
		return this;
	}])
	.run(['cianUiScrollWidth', (cianUiScrollWidth) => {
		cianUiScrollWidth.cache();
	}])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/scroll-width/index.jsm